var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateReplyThread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2106_29303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.715429 16.4048L17.677 9.48166C17.8723 9.40192 18 9.2119 18 9.00093C18 8.78996 17.8723 8.59994 17.677 8.5202L0.715429 1.59713C0.506847 1.51198 0.267153 1.57108 0.122028 1.74341C-0.0229912 1.91575 -0.0405007 2.16195 0.0788898 2.35306L4.23383 9.00093L0.0789255 15.6488C0.0260156 15.7334 -6.23772e-07 15.8288 -6.27927e-07 15.9239C-6.33154e-07 16.0435 0.0412019 16.1625 0.122062 16.2584C0.26715 16.4308 0.506883 16.4899 0.715429 16.4048Z",
    fill: "#C1CEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2106_29303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateReplyThread);
export default __webpack_public_path__ + "static/media/create-reply-thread.78167f133d5efce231425bc229f3f20a.svg";
export { ForwardRef as ReactComponent };